export const ROLE_NAMES = {
  SUPER_ADMIN: 'super admin',
  ADMIN: 'admin',
  PROJECT_ADMIN: 'project admin',
  USER: 'user',
} as const;

export const ADMIN_ROLE_SET = new Set<string>([
  ROLE_NAMES.SUPER_ADMIN,
  ROLE_NAMES.ADMIN,
  ROLE_NAMES.PROJECT_ADMIN,
]);
